<!--
  Created by:Upendram Reddy Tanuja
  Created on: 05-Aug-2019 12:30 PM
  Purpose: profile setting component
-->

<div mat-dialog-title>
  My Profile
  <i class="fa fa-times pt-2 pr-3 float-right" (click)="cancelProfile()"></i>
</div>
<div mat-dialog-content>
  <div class="form-group  mb-4">
    <div class="image-upload">
      <img *ngIf="!attachment_id" src="{{imgs || default_imgs}}" alt="Avatar" class="img-circle">
      <img *ngIf="attachment_id" src="{{profile_settings.files.file_path}}" alt="Avatar" class="img-circle">
      <label for="file-input">
        <i class="fa fa-pencil" matTooltip="Change Profile"></i>
      </label>

      <input id="file-input" type="file" (change)="filechange($event)" [(ngModel)]="FileName" accept="image/*" />
    </div>
    <div *ngIf="profile_list">
      <h5 class="text-center mb-1" style="color: rgba(0,0,0,.54);word-break: break-all;">
        {{profile_list.name}}</h5>
      <p class="mt-2 mb-0" class="text-center" *ngIf="profile_list && (profile_list.mobile_no || profile_list.email_id || profile_list.date_of_birth || profile_list.organization_node_title || (user_type && user_type.length))">
        <span class="mb-1 profile-list" *ngIf="profile_list && profile_list.email_id">
          <i class="fa fa-envelope-o " aria-hidden="true"></i>
          {{profile_list.email_id}}
        </span>
        <span class="mb-1 profile-list" *ngIf="profile_list && profile_list.date_of_birth">
          <i class="fa fa-calendar " aria-hidden="true" *ngIf="profile_list && profile_list.date_of_birth"></i> {{profile_list.date_of_birth | date: 'd-MMM-yyyy'}}
        </span>
        <span class="mb-1 profile-list" *ngIf="profile_list && profile_list.organization_node_title">
          <i class="fa fa-briefcase " aria-hidden="true"></i>
          {{profile_list.organization_node_title}}
        </span>
        <span class="mb-1 profile-list" *ngIf="user_type && user_type.length">
          <i class="fa fa-users" aria-hidden="true"></i>
          {{user_type}}
        </span>
      </p>
    </div>

    <!-- <form [formGroup]="profile_settings_form">
      <div class="row">
        <div class="col-md-12 form-group">
          <mat-form-field floatLabel="always" class="mt-3">
            <mat-label>{{'1_300_1000750_1003' | translate}}</mat-label>
            <mat-select name="assign-to" placeholder="{{'1_300_1000710_1032' | translate}}" formControlName="assign_to">
              <mat-option>
                {{'1_300_1000710_1033' | translate}}
              </mat-option>
              <mat-option *ngFor="let assign of master['assign_to']" [value]="assign.assign_id">
                {{assign.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-12">
          <app-phone-number [placeholder]="'Mobile Number'" [form]="profile_settings_form" controlName="mobile_no" [label]="'Mobile Number'"
            [data]="profile_settings_form.value['mobile_no']">
          </app-phone-number>
        </div>
        <div class="col-md-6 form-group">
          <mat-form-field floatLabel="always">
            <mat-label>Extension Number</mat-label>
            <input name="extension_number" class="w-93" type="number" matInput placeholder="Extension Number" formControlName="extension_number">
          </mat-form-field>
        </div>
        <div class="col-md-6 form-group">
          <mat-form-field floatLabel="always">
            <mat-label>Time Zone</mat-label>
            <mat-select name="time_zone" placeholder="{{'1_300_1000710_1032' | translate}}" formControlName="time_zone_id">
              <mat-option>
                {{'1_300_1000710_1033' | translate}}
              </mat-option>
              <mat-option *ngFor="let time of master['time_zone']" [value]="time.time_zone_id">
                {{time.time_zone}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-12">
          <mat-form-field floatLabel="always">
            <mat-label>{{'1_300_1000750_1001' | translate}}</mat-label>
            <textarea name="short-signature" class="w-93" matInput placeholder="{{'1_300_1000750_1001' | translate}}" formControlName="short_signature"></textarea>
          </mat-form-field>
        </div>
        <div class="col-md-12">
          <app-html-text-editor [form]="profile_settings_form" controlName="long_signature" [label]="'Long Signature'">
          </app-html-text-editor>
        </div>

      </div>
    </form> -->
    <tm-dynamic-form *ngIf="masters && section_data" [section_list]="section_data" [masters]="masters" [display_type]="display_type"
      [dynamic_form]="dynamic_form" [dataSaved]="dataSavedRef">
    </tm-dynamic-form>
  </div>
</div>
<div mat-dialog-actions>
  <button class="float-right ml-1 btn btn-sm btn-info" (click)="saveProfile()">
    Save
  </button>
  <button class="float-right ml-auto btn btn-sm btn-danger" (click)="cancelProfile()">
    Cancel
  </button>
</div>